// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Roboto Mono', 'Roboto Mono Fallback'","fontStyle":"normal"},"className":"__className_5899e0"};